import React from 'react';
import CustomScrollbar from 'js/common/components/CustomScrollbar';
import { TextField, MenuItem, FormControlLabel, Checkbox, RadioGroup,
	Radio, FormLabel } from '@mui/material';
import { getI18NMessage, getI18NMessageString } from 'I18N/I18NHelper';
import AppHelper from 'js/app/AppHelper';
import { BOARD_MESSAGE_CONSTANT } from 'js/modules/message/constants/MessageConstants';
import { showMessage } from 'js/modules/message/actions/MessageActions';
import AppUtil, { getAppStore } from 'js/utils/AppUtil';
import properties from 'properties';
import { GLOBAL_CONSTANTS, APP_URL_CONSTANTS } from 'js/common/constants/GlobalConstants';
import RTF from 'js/common/components/RTF';
import { getFormatedDate, convertImoticonTextToHexCodeText } from 'js/utils/GeneralUtil';
import Button from '@mui/material/Button';
import Autocomplete from '@mui/material/Autocomplete';

class IssueCollectorPreview extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			issueTitle: "",
			issueDescription: "",
			yourName: "",
			yourEmailId: "",
			attachmentName: "",
			attachmentFile: "",
			errorLabelList: [],
			isCaptchaValid : false,
			selectedCustomFieldValues: [],
			customMandatory: [],
			urlVarsData: []
		};

		this.appStore = getAppStore();
	}

	getControlTag (data, UrlData) {
		const urlVal = UrlData[(data.fieldLabel.split(' ').join('_'))] || "";

		const multiSelectOptions = data.valueList && 
			data.valueList.map(val=> {return {title: val}})
		
		const rtfCfg = {
            toolbar: 'fontfamily fontSize | bold italic underline strikethrough | justifyLeft justifyCenter justifyRight justify | ' +
				'unordered-list-item ordered-list-item | backgroundColor fontColor | link removeLink'
		};

		switch(data.controlType) {
			case GLOBAL_CONSTANTS.TEXTBOX:
				return (
					<div className = "control_wrapper" key={data.order}>
						<TextField fullWidth className="preview_control" label={data.fieldLabel} variant="outlined" 
						required = {data.selectedType === "mandatory"} disabled= {this.props.isDisabled === true}
						type={data.dataType} onChange={this.oncustomFieldChange.bind(this, data)}
						error={ this.state.customMandatory.indexOf(data.fieldLabel) !== -1 }  inputProps={{ maxLength: data.maxCharLimit}}
						defaultValue= {urlVal}/>
					</div>
				)
			case GLOBAL_CONSTANTS.TEXTAREA:
					return (
						<div className = "control_wrapper" key={data.order}>
							<TextField fullWidth className="preview_control" label={data.fieldLabel} variant="outlined"
							multiline rows = "3" required = {data.selectedType === "mandatory"} disabled= {this.props.isDisabled === true}
							onChange={this.oncustomFieldChange.bind(this, data)} inputProps={{ maxLength: data.maxCharLimit}}
							error={ this.state.customMandatory.indexOf(data.fieldLabel) !== -1 }
							defaultValue= {urlVal} />
						</div>
					)	
			case GLOBAL_CONSTANTS.COMBO:
				return (
					<div className = "control_wrapper" key={data.order} >
						<TextField select fullWidth label={data.fieldLabel} required = {data.selectedType === "mandatory"} variant="outlined"
						disabled= {this.props.isDisabled === true} onChange={this.oncustomFieldChange.bind(this, data)}
						error={ this.state.customMandatory.indexOf(data.fieldLabel) !== -1 } inputProps={{ maxLength: data.maxCharLimit}}
						defaultValue={urlVal}>
						{
							data.valueList.map(option => (
								<MenuItem key={ option} value={ option }>{ option }</MenuItem>
							))
						}
					</TextField>
				</div>
				)
			case GLOBAL_CONSTANTS.CHECKBOX:
				return (
					<div className = "control_wrapper" key={data.order} >
						<FormControlLabel
            				control={<Checkbox disabled= {this.props.isDisabled === true} onChange={this.oncustomFieldChange.bind(this, data)}/>}
           					 label={data.fieldLabel} error={ this.state.customMandatory.indexOf(data.fieldLabel) !== -1 }/>
					</div>
				)
			case GLOBAL_CONSTANTS.RADIOBUTTON: 
				return (
					<div className = "control_wrapper" key={data.order} >
						<FormLabel component="legend">{data.fieldLabel}</FormLabel>
						<RadioGroup onChange={this.oncustomFieldChange.bind(this, data)}
						error={ this.state.customMandatory.indexOf(data.fieldLabel) !== -1 }>
							{
							data.valueList.map(option => (
								<FormControlLabel key={ option} value={option} disabled= {this.props.isDisabled === true} 
								control={<Radio />} label={option} />
							))
						}
						</RadioGroup>
					</div>
				)
			case GLOBAL_CONSTANTS.REACH_TEXTBOX:
				return (
					<div className = "control_wrapper" key={data.order} >
						<FormLabel component="legend">{data.fieldLabel}
						{data.selectedType === "mandatory" && <span className="desc-asterisk">*</span>}
						</FormLabel>
						<RTF config={ rtfCfg } isEditable={ this.props.isDisabled !== true } store={ this.props.store }
						onChange={ this.oncustomFieldChange.bind(this, data) } required = {data.selectedType === "mandatory"}
						error={ this.state.customMandatory.indexOf(data.fieldLabel) !== -1 }></RTF>
					</div>
				)
			case GLOBAL_CONSTANTS.MULTISELECT:
				return this.renderMultiselect(data, multiSelectOptions);
			case GLOBAL_CONSTANTS.MULTISELECTLIST:
				return this.renderMultiselect(data, multiSelectOptions);
			default:
				return (
					<div className = "control_wrapper">
						<div>Unknown control type</div>
					</div>
				)
		}
	}

	renderMultiselect(data, multiSelectOptions) {
		const w_selectedCustomFields = this.state.selectedCustomFieldValues;
		const selectedOpt = w_selectedCustomFields.find(field => field.controlType === data.controlType && field.fieldLabel === data.fieldLabel &&
			field.fieldName === data.fieldName);
		const selectedVal = multiSelectOptions.filter (selVal => selectedOpt && selectedOpt.value.includes(selVal.title))
		return (
			<div className = "control_wrapper" key={data.order} >
				<Autocomplete 
				className="preview_control" 
				size="small"
				margin="dense"
				label={data.fieldLabel} 
				disabled= {this.props.isDisabled === true}
				value={selectedVal}
				multiple
				limitTags = {3}
				onChange={this.oncustomFieldChange.bind(this, data)}
				id="checkboxes-tags-demo"
				options={multiSelectOptions}
				disableCloseOnSelect
				getOptionLabel={option => option.title}
				renderOption={(props, option) => (
					<li {...props}>
					<Checkbox
						color = "primary"
						style={{ marginRight: 8 }}
						checked={selectedOpt ? selectedOpt.value.includes(option.title) : false}
					/>
					{option.title}
					</li>
				)}
				renderInput={params => (
					<TextField {...params}
					className="preview_control" 
					label={data.fieldLabel} 
					disabled= {this.props.isDisabled === true}
					variant="outlined"
					fullWidth
					required = {data.selectedType === "mandatory"} 
					error={ this.state.customMandatory.indexOf(data.fieldLabel) !== -1 }/>
				)}
				/>
		</div>
		)
	}

	oncustomFieldChange (a_data, el, selectedVals, option, currentSelection) {
		const w_fieldLabel = a_data.fieldLabel;
		const w_fieldName = a_data.fieldName;
		const w_controlType = a_data.controlType;
		const w_dataType = a_data.dataType;
		
		let w_customFieldValues = this.state.selectedCustomFieldValues;
		let w_value = "";
		if (w_controlType === "RText") {
			w_value = el;
		} else if (w_controlType === GLOBAL_CONSTANTS.MULTISELECT || 
			w_controlType === GLOBAL_CONSTANTS.MULTISELECTLIST) {
			const selectedFields = selectedVals && selectedVals.map (val => val.title);

			if (w_controlType === GLOBAL_CONSTANTS.MULTISELECT) {
				if (currentSelection.option.title === "None") {
					if (!selectedFields.includes("None")) {
						w_value = selectedFields
					} else {
						w_value = ["None"]
					}
				} else {
					w_value = selectedFields.filter(fl => fl !== "None");
				}
			} else {
				w_value = selectedFields.join(',')
			}
		} else if (el.target.type === "checkbox") {
			if (el.target.checked) {
				w_value = "Y";
			} else {
				w_value = "N";
			} 
		} else if(el.target.type === "date") {
			const w_selectedDate = el.target.value;
			el.target.className += (w_selectedDate !== ''?' has-value':'')
			w_value = getFormatedDate(w_selectedDate)
		} else{
			w_value = el.target.value;
		}
		
		if ((typeof w_value === "string" && w_value.trim()) ||
		(typeof w_value === "object")) {
			const field = {
				fieldLabel: w_fieldLabel,
				fieldName: w_fieldName,
				value : w_value,
				controlType: w_controlType,
				dataType: w_dataType
			}
			w_customFieldValues = w_customFieldValues.filter(fieldVal => fieldVal.fieldLabel !== w_fieldLabel)
			w_customFieldValues.push(field);
		}
		
		this.setState({selectedCustomFieldValues: w_customFieldValues})
	}

	checkMandatoryBeforeSubmit(a_selectedCustomFields) {
		const issueConfig = this.appStore.getState().issueConfig.issueConfig.config
		const w_mandatoryFields = []
		const w_customMandatory = []
		issueConfig.customFields && issueConfig.customFields.forEach(item=> {
			if(item.selectedType === "mandatory"){
				w_mandatoryFields.push(item.fieldLabel)
			}
		}) 
		const selectedArr = [];
		a_selectedCustomFields.forEach(obj => {
			selectedArr.push(obj.fieldLabel)
		})
		
		w_mandatoryFields.forEach(key => {
			if(!selectedArr.includes(key)) {
				w_customMandatory.push(key)
			}
		})

		this.setState({customMandatory: w_customMandatory});

		return w_customMandatory;
	}

	/* istanbul ignore next */
	closeICForm() {
		window.parent.postMessage("CloseIssueCollectorWindow", "*");
	}

	icFormSubmit() {
		const icConfig = this.appStore.getState().issueConfig.issueConfig.config;
		const urlVars = this.state.urlVarsData;
		let description = this.state.issueDescription;
		const w_selectedCustomFields = this.state.selectedCustomFieldValues;
		const w_validatedCustomMandatoryField = this.checkMandatoryBeforeSubmit(w_selectedCustomFields);
		const w_allowedEmailIds = icConfig.allowedEmailIds;
		let w_allowEmailArr = []

		if (w_allowedEmailIds) {
			w_allowEmailArr = w_allowedEmailIds.split(",")
		}

		if (icConfig.descriptionControlType === "RTF") {
			description += "<p></p><p><strong>Submitted by: </strong> "+ this.state.yourName +
			"</p><p><strong>Email ID: </strong> "+ this.state.yourEmailId +"</p>";
			
			if (icConfig.screentitle && icConfig.screentitle.trim()) {
				description += "<p><strong>Source: </strong> " + this.sanitizeURLs(icConfig.screentitle, false) + " </p>";
			}
		} else {
			description += "<br><br>Submitted by: " + this.state.yourName + 
			"<br>Email ID: " + this.state.yourEmailId;

			if (icConfig.screentitle && icConfig.screentitle.trim()) {
				description += "<br>Source: " + icConfig.screentitle;
			}
		}
		const errorLabelList = [];
		const customFields = icConfig.customFields;
		let fieldOrderStr = ""
		customFields.sort(function(a,b){
			return a.order - b.order;
			}
		);
		
		customFields.forEach(field => {
			fieldOrderStr += field.fieldLabel + "^*!^";
		})

		if (fieldOrderStr.endsWith("^*!^")) {
			fieldOrderStr = fieldOrderStr.substring(0, fieldOrderStr.length - 4)
		}
		const fieldOrder = {
			fieldLabel: "ISSUE_COLLECTOR_FIELD_LIST",
			fieldName: "ISSUE_COLLECTOR_FIELD_LIST",
			value : fieldOrderStr,
			controlType: "Text",
			dataType: "String"
		}
		w_selectedCustomFields.push(fieldOrder)

		const reporterName = {
			fieldLabel: "ISSUE_COLLECTOR_REPORTER_NAME",
			fieldName: "ISSUE_COLLECTOR_REPORTER_NAME",
			value : this.state.yourName,
			controlType: "Text",
			dataType: "String"
		}
		w_selectedCustomFields.push(reporterName)

		const reporterEmail = {
			fieldLabel: "ISSUE_COLLECTOR_REPORTER_EMAILID",
			fieldName: "ISSUE_COLLECTOR_REPORTER_EMAILID",
			value : this.state.yourEmailId,
			controlType: "Text",
			dataType: "String"
		}
		w_selectedCustomFields.push(reporterEmail)
		const w_todayDate = new Date();
		const monthsArr = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
		
		description = convertImoticonTextToHexCodeText(description);
		const w_data = {
			description,
			cardName: this.state.issueTitle,
			itemType: icConfig.cardtype,
			createdOn: (w_todayDate.getDate() +"-"+ monthsArr[w_todayDate.getMonth()]+"-"+w_todayDate.getFullYear()),
			projectId: icConfig.projectid,
			customFields: w_selectedCustomFields,
			HASRTFCONTENT: "Y"
		}

		if (this.state.attachmentName !== "" && this.state.attachmentFile !== "" ) {
			w_data.attachmentName = this.state.attachmentName;
			w_data.attachmentFile = this.state.attachmentFile;
		}

		if (!w_data.cardName.trim()) {
			errorLabelList.push("ic_issue_name")
		}
		if (!this.state.issueDescription.trim()) {
			errorLabelList.push("ic_desc_Pre_title")
		}
		if (!this.state.yourName.trim()) {
			errorLabelList.push("ic_your_name")
		}
		if (!this.state.yourEmailId.trim()) {
			errorLabelList.push("ic_your_id")
		}

		this.setState({
			errorLabelList
		});

		if (AppHelper.getAppData("google_recaptcha_enabled") === "true" && !this.state.isCaptchaValid) {
			this.props.store.dispatch(showMessage({
				type: BOARD_MESSAGE_CONSTANT.TYPE_WARNING,
				message: getI18NMessage( 'invalidCaptchaError' )
			}));
		} else if(w_allowEmailArr.length > 0 && !w_allowEmailArr.includes(this.state.yourEmailId)){
			this.props.store.dispatch(showMessage({
				type: BOARD_MESSAGE_CONSTANT.TYPE_WARNING,
				message: getI18NMessage( 'notAllowedToAddWrkReq' )
			}));
		} else if ( errorLabelList.length > 0 || w_validatedCustomMandatoryField.length > 0) {
			this.props.store.dispatch(showMessage({
				type: BOARD_MESSAGE_CONSTANT.TYPE_WARNING,
				message: getI18NMessage( 'emptyMandatoryError' )
			}));
		} else  if (!AppHelper.isValidEmailId(this.state.yourEmailId)) {
			this.props.store.dispatch(showMessage({
				type: BOARD_MESSAGE_CONSTANT.TYPE_WARNING,
				message: getI18NMessage( 'envalidEmailId' )
			}));
		} else {
			const w_hiddenFields = [];

			Object.keys(urlVars).forEach((key) => {
				if (key.startsWith(GLOBAL_CONSTANTS.HIDDEN_FEILD_PREFIX)) {
					const splitKey = key.split(GLOBAL_CONSTANTS.HIDDEN_FEILD_PREFIX);
					if (splitKey.length > 1) {
						const fieldLabel = splitKey[1].replaceAll('_', ' ');
						const hiddenField = {
							fieldLabel: fieldLabel,
							value : urlVars[key],
						}
						w_hiddenFields.push(hiddenField)
					}
				}
			});	

			if (w_hiddenFields.length) {
				w_data.hiddenFields = w_hiddenFields;
			}

			this.props.addNewIssue(w_data, urlVars)
		}
	}
	
	componentDidMount () {
		if (this.props.openFrom === "outside") {
			const urlVars = AppHelper.getUrlVarsFromUrl(window.location.href)
			this.props.getIssueCollectorData(urlVars, this.loadCustomFields.bind(this));
			this.setStateForAutoPopulateFiels(urlVars)
			this.setState({urlVarsData: urlVars})
		} 
	}

	setStateForAutoPopulateFiels(data) {
		if (data.Email_Address) {
			this.setState({yourEmailId: data.Email_Address})
		}

		if (data.Name) {
			this.setState({yourName: data.Name})
		}

		if (data.Description) {
			this.setState({issueDescription: data.Description})
		}

		if (data.Issue_Title) {
			this.setState({issueTitle: data.Issue_Title})
		}
	}

	loadCustomFields () {
		const issueConfig = this.appStore.getState().issueConfig.issueConfig.config
		this.props.getCustomFields(issueConfig.cardtype, issueConfig.customFields, true, issueConfig.id, "outside");
	
		const urlVars = this.state.urlVarsData;
		issueConfig.customFields && issueConfig.customFields.forEach(item=> {
			const autoVal = urlVars[item.fieldLabel.split(' ').join('_')]

			if(autoVal) {
				this.oncustomFieldChange(item, {target: {value: autoVal}})
			}
		})
	}

	onTitleChange(el) {
		this.setState({issueTitle:el.target.value})
	}

	onDescriptionChange(type, el) {
		let w_description = ""
		if (type === 'RTF') {
			w_description = el;
		} else {
			w_description = el.target.value;
		}
		this.setState({issueDescription:w_description})
	}

	onNameChange(el) {
		this.setState({yourName:el.target.value})
	}

	onEmailChange(el) {
		this.setState({yourEmailId:el.target.value})
	}

	/* istanbul ignore next */
	onAttachmentChange(e) {
		const that = this;
		const file = e.target.files[0];
		const maxFileSizeLimit = AppHelper.getAppData('sourceProperties').attachmentSize;

		if ( file.size / 1024 > maxFileSizeLimit ) {
			const displaySourceAttachSize = maxFileSizeLimit / 1024;

			e.target.value = "";
			this.props.store.dispatch(showMessage({
				type: BOARD_MESSAGE_CONSTANT.TYPE_WARNING,
				message: getI18NMessageString( 'fileSizeWarning' ).replace('#SIZELIMIT#', `${displaySourceAttachSize >= 1 ? ( Math.round(displaySourceAttachSize) + 'MB' ) : '500KB'}`)
			}));

			return false;
		}

		this.setState({attachmentName:file.name})

		return new Promise((resolve, reject) => {
			const reader = new FileReader();

			reader.onload = event => {
				resolve(that.setState({attachmentFile:(event.target.result.split('base64,')[1])}));
			};

			reader.onerror = err => {
				reject(err);
			};

			reader.readAsDataURL(file);
		});
	}

	sanitizeURLs(text, isHtmlObj) {
		const regex = /URL_START\s(.*?)\sURL_END\sURLNAME_START\s(.*?)\sURLNAME_END/g;
		const htmlObj = [];
		let htmlString = "";
		let lastIndex = 0;
		let match;
	
		while ((match = regex.exec(text)) !== null) {
			htmlObj.push(text.substring(lastIndex, match.index));
			htmlObj.push(
				<a href={match[1]} key={match.index} target='_blank' rel="noopener noreferrer">
				{match[2]}
				</a>
			);

			htmlString += text.substring(lastIndex, match.index);
			htmlString += `<a href="${match[1]}" target="_blank" rel="noopener noreferrer">${match[2]}</a>`;
		
			lastIndex = regex.lastIndex;
		}
	
		htmlObj.push(text.substring(lastIndex));
		htmlString += text.substring(lastIndex);
	
		if(isHtmlObj) {
			return <>{htmlObj}</>;
		}
		else {
			return htmlString;
		}
  	}

	render() {
		if ( Object.keys(this.props).length === 0 || !this.appStore.getState().issueConfig.issueConfig 
			|| !this.appStore.getState().issueConfig.issueConfig.config ) {
			return false;
		} 

		const issueConfig = this.appStore.getState().issueConfig.issueConfig.config
		const isFormDisabled = this.props.isDisabled === true

		if (issueConfig.status !== "disabled" && this.props.openFrom === "outside" && AppHelper.getAppData("google_recaptcha_enabled") === "true" && !window.grecaptcha ){
			this.loadScript();
		}

		const mandatoryFields = issueConfig.customFields && issueConfig.customFields.filter(function(item){
			return item.selectedType === "mandatory";
		});

		const nonMandatoryFields = issueConfig.customFields && issueConfig.customFields.filter(function(item){
			return item.selectedType === "nonmandatory";
		});

		const sortedMandatoryFields = mandatoryFields && mandatoryFields.sort( (a,b) => a.order < b.order ? -1 : 1 );

		const sortedNonMandatoryFields = nonMandatoryFields && nonMandatoryFields.sort( (a,b) => a.order < b.order ? -1 : 1 );
		const urlVars = AppHelper.getUrlVarsFromUrl(window.location.href) || [];

		const RTFConfig = {
            toolbar: 'fontfamily fontSize | bold italic underline strikethrough | justifyLeft justifyCenter justifyRight justify | ' +
				'unordered-list-item ordered-list-item | backgroundColor fontColor | link removeLink image fullscreen',
				defaultValue: urlVars.Description
		};
		const isOpenFromOutside = this.props.openFrom === "outside";
		const customCls = window.location.search.includes('source') && !window.location.search.includes('PopupMode=Y') ? 'open_from_mail' : '';

		return (
			<React.Fragment>
				<div className={`work_request_container ${customCls}`}>
				{
					issueConfig.status !== "disabled" &&
						<div className={`ic_wrapper ${ isOpenFromOutside ? '' : 'ic_wrapper_full_height' }`}>
							<div className = "template_header">
								<span className = "form_title">{issueConfig.screentitle ? this.sanitizeURLs(issueConfig.screentitle, true): getI18NMessage("screen_title")}</span>
							</div>
							<CustomScrollbar className = "template_body" style={{ height: 'calc(100% - 40px)', width: '100%' }}>
								<div className="introduction_text control_wrapper">
									<span className= "icon-Exclamation"></span>
									<span className = "text">{issueConfig.introductiontext ? this.sanitizeURLs(issueConfig.introductiontext, true) : getI18NMessage("introduction_text") }</span>
								</div>
								<div className = "control_wrapper">
									<TextField required fullWidth error={ this.state.errorLabelList.indexOf('ic_issue_name') !== -1 } id="ic_issue_name" variant="outlined"
									label = {issueConfig.issuetitle ? issueConfig.issuetitle : getI18NMessage("issue_title")}
									disabled = {isFormDisabled} onChange={this.onTitleChange.bind(this)} defaultValue = {urlVars.Issue_Title}/>
								</div>
								{issueConfig.descriptionControlType === "RTF" &&
								<div className = "control_wrapper">
									<FormLabel component="legend">{issueConfig.descriptiontitle ? this.sanitizeURLs(issueConfig.descriptiontitle, true) : getI18NMessage("description_title")}
									<span className="desc-asterisk">*</span>
									</FormLabel>
									<RTF store={ this.props.store } required= {true} config={ RTFConfig } isEditable={ this.props.isDisabled !== true }
									onChange={ this.onDescriptionChange.bind(this, "RTF") } error={ this.state.errorLabelList.indexOf('ic_desc_Pre_title') !== -1 }></RTF>
								</div>
								}
								{issueConfig.descriptionControlType !== "RTF" &&
								<div className = "control_wrapper">
									<TextField required multiline fullWidth rows="4" error={ this.state.errorLabelList.indexOf('ic_desc_Pre_title') !== -1 } id="ic_desc_Pre_title" variant="outlined"
									label = {issueConfig.descriptiontitle ? issueConfig.descriptiontitle : getI18NMessage("description_title")}
									disabled = {isFormDisabled} onChange={this.onDescriptionChange.bind(this, "nonRTF")} defaultValue = {urlVars.Description}/>
								</div>
								}
								{
									sortedMandatoryFields && sortedMandatoryFields.map( data => this.getControlTag(data, urlVars) )
								}
								{
									sortedNonMandatoryFields && sortedNonMandatoryFields.map( data => this.getControlTag(data, urlVars) )
								}
								{
									issueConfig.isattachmentavailable &&
									<div className = "control_wrapper">
										<div className="attach_file_label">{getI18NMessage("attach_file")}</div>
										<input type="file" id="ic_form_attachment" disabled = {isFormDisabled}
										onChange={this.onAttachmentChange.bind(this)}></input>
									</div>
								}
								<div className = "control_wrapper">
									<TextField required fullWidth error={ this.state.errorLabelList.indexOf('ic_your_name') !== -1 } id="ic_your_name" className="ic_your_name" label={getI18NMessage("your_name")} variant="outlined"
									defaultValue = {urlVars.Name} disabled = {isFormDisabled} onChange={this.onNameChange.bind(this)}/>
								</div>
								<div className = "control_wrapper">
									<TextField required error={ this.state.errorLabelList.indexOf('ic_your_id') !== -1 } id="ic_your_id" className="ic_your_id" label={getI18NMessage("your_emailid")}  fullWidth  variant="outlined"
									defaultValue = {urlVars.Email_Address} disabled = {isFormDisabled} onChange={this.onEmailChange.bind(this)} />
								</div>
								<div className = "control_wrapper">
									<div className = "captcha_wraper" id = "captcha_wraper"></div>
								</div>
							</CustomScrollbar>
						</div>
				}
				{issueConfig.status === "disabled" &&
				<div className="ic_deleted_disabled">
					<img src={ AppUtil.processURLForAppContextPath('images/ic_disabled_error.png') } alt="msg_illustratio"></img>
				</div>
				}
				<div className = "template_footer">
					<div className='float_right full_height'>
						{
							( window.name || ( window.location.href.indexOf('/form') === -1 && AppHelper.getParamData('icForm') !== 'Y' ) ) &&
								<Button color="primary" onClick={ this.closeICForm.bind(this) }
									disabled={ (issueConfig.status === "disabled" || isFormDisabled) }>{ getI18NMessage("cancel") }</Button>
						}
						<Button variant="contained" color="primary" 
							onClick={ (issueConfig.status === "disabled" || isFormDisabled) ? () => {
								// dummy fn
							} : this.icFormSubmit.bind(this) }
							disabled={ (issueConfig.status === "disabled" || isFormDisabled) }>{ getI18NMessage("submit") }</Button>
					</div>
				</div>
			</div>
		</React.Fragment>		
		);
	}

	/* istanbul ignore next */
	loadScript(){
		const url = properties.recaptchaApi;
		const queryString = '?render=explicit';
		const script = document.createElement('script')
		script.type = 'text/javascript'
		script.src = url + queryString
		script.async = true
		script.defer = true
		script.addEventListener("load", this.handleOnLoad.bind(this))
		this.script = document.body.appendChild(script)
	}

	/* istanbul ignore next */
	handleOnLoad(){
		const component = this;
		const sitekey = AppHelper.getAppData("google_recaptcha_sitekey");

		window.grecaptcha.ready(function() {
			const clientId = window.grecaptcha.render('captcha_wraper', {
				sitekey,
				badge: 'inline',
				size: 'invisible'
			});
			
			window.grecaptcha.execute(clientId, {action: 'IssueCollectorForm'}).then(function(token) {
			   component.verifyRecaptcha(token);
			}, 
			function(){
				component.appStore.dispatch(showMessage({
					type: BOARD_MESSAGE_CONSTANT.TYPE_WARNING,
					message: getI18NMessage( 'invalidCaptchaDomain' )
				}));
			});
		});
	}

	/* istanbul ignore next */
	verifyRecaptcha(token){
		const component = this;
		const data = {
			"response": token
		}
		const w_url = properties.url + APP_URL_CONSTANTS.VERIFY_GOOGLE_RECAPTCHA+ "/" + AppHelper.getParamData('sologinid');
		AppUtil.ajax(w_url, data, response =>{
			if(response.success === true){
				if(response.score >= 0.4){
					component.setState({"isCaptchaValid": true})
				}else{
					component.setState({"isCaptchaValid": false})
				}
			}else{
				component.setState({"isCaptchaValid": false})
			}
		});
	}
}

export default IssueCollectorPreview;